module.exports = __webpack_public_path__ + "static/media/Grammar_Symbols_Glossary.5ddb69c8.pdf";